import { z } from '../zod.js';

// All field types (includes empty string + po-number + company-name)
export const FieldTypeValidationEnum = z.enum([
  '',
  'company-name',
  'po-number',
  'name',
  'first-name',
  'last-name',
  'company-name',
  'email',
  'billing-email',
  'phone',
  'address-line1',
  'address-city',
  'address-country',
  'address-line2',
  'address-postal_code',
  'address-state',
  'shipping-name',
  'shipping-phone',
  'shipping-address-line1',
  'shipping-address-city',
  'shipping-address-country',
  'shipping-address-line2',
  'shipping-address-postal_code',
  'shipping-address-state',
  'tax-id',
]);

// All field element types (form elements + personal ones), in the same
// order as the API model's fieldElementTypes — locked by chargeEnumParity.test.ts.
export const FieldElementValidationEnum = z.enum([
  'checkbox',
  'quantity',
  'multiple-choice',
  'select',
  'multi-select',
  'po-number',
  'text',
  'textarea',
  'number',
  'date-time',
  'date',
  'time',
  'address',
  'email',
  'tax-id',
  'phone',
  'country',
]);
